// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__Xc-8x","player":"style_player__23N5n","playersFormImage":"style_playersFormImage__z0OhA"};